import { userApi } from '@api/user';
import { InputFormField } from '@ui/Form/Fields';
import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { I18n, Translate } from 'react-redux-i18n';
import {
  DEFAULT_REGISTRATION_AGE,
  MAX_AGE,
  NICKNAME_PATTERN,
} from '../constants';
import styles from './styles.module.scss';

const Form = () => {
  const [step, setStep] = useState(0);
  const { trigger, watch, setError, setValue } = useFormContext();

  const onNextStep = async () => {
    const rawName = watch('name') || '';
    const nick = rawName.trim();

    if (nick !== rawName) {
      setValue('name', nick, { shouldValidate: true });
    }

    if (!NICKNAME_PATTERN.test(nick)) {
      setError('name', {
        type: 'manual',
        message: I18n.t('register.errors.nickname.wrong'),
      });
      return;
    }

    const isValidCurrentStepFields = await trigger(['name', 'password']);
    if (!isValidCurrentStepFields) {
      return;
    }

    try {
      const isNickTaken = await userApi.checkNickname(nick);
      if (isNickTaken) {
        setError('name', {
          type: 'manual',
          message: I18n.t('register.errors.nickname.taken'),
        });
        return;
      }
    } catch (error) {
      setError('name', {
        type: 'manual',
        message: I18n.t('register.errors.nickname.checkFailed'),
      });
      return;
    }

    const ageValue = watch('age');
    const age =
      ageValue === undefined || ageValue === null
        ? DEFAULT_REGISTRATION_AGE
        : ageValue;
    setStep(age < MAX_AGE ? 1 : 2);
  };

  const onBackStep = () => setStep(0);

  const ConfirmButtons = () => (
    <div className={styles.submitContainer}>
      <button
        type="button"
        className={styles.backButton}
        onClick={onBackStep}
        aria-label="back"
      >
        <i className="fa fa-arrow-left" aria-hidden="true" />
      </button>
      <button type="submit" className={styles.submitButton}>
        <Translate value="auth.signup" />
      </button>
    </div>
  );

  return (
    <>
      {step === 0 && (
        <>
          <InputFormField name="name" placeholder={I18n.t('register.nick')} />
          <InputFormField
            type="password"
            name="password"
            placeholder={I18n.t('placeholder.password')}
            autoComplete="off"
          />

          <button
            type="button"
            className={styles.submitButton}
            onClick={onNextStep}
          >
            <Translate value="gui.sidebar.nav.next" />
          </button>
        </>
      )}

      {step === 1 && (
        <>
          <InputFormField
            name="parentRealName"
            placeholder={I18n.t('register.parentName')}
          />
          <InputFormField
            name="parentEmail"
            placeholder={I18n.t('register.parentEmail')}
          />
          <InputFormField
            name="parentPhone"
            placeholder={I18n.t('register.parentPhone')}
          />
          <ConfirmButtons />
        </>
      )}

      {step === 2 && (
        <>
          <InputFormField
            name="email"
            placeholder={I18n.t('placeholder.email')}
          />
          <InputFormField
            name="realName"
            placeholder={I18n.t('placeholder.name')}
          />
          <ConfirmButtons />
        </>
      )}
    </>
  );
};

export default Form;
